<!--The content below is only a placeholder and can be replaced.-->
<global-header></global-header>
<main>
    <router-outlet></router-outlet> 
</main>
<aa-loading-spinner></aa-loading-spinner>